import {isReleasedRedesignRecruitment} from '../../../../../config/unReleasePage';
import {RECRUITMENT_SCHEDULE_WARNING_STATUS} from '../../../../../core/entities/recruitment/constants';
import type {RecruitmentScheduleWarning} from '../../../../../core/entities/recruitment/schema';
import {getScheduleWarningStatus} from '../../../usecases/getScheduleWarningStatus';

export const ScheduleWarning: React.FC<{
  companyName: string;
  scheduleWarning: RecruitmentScheduleWarning;
  hasOtherRecruitmentList: boolean;
  displayEndAt?: string;
  scrollToOtherRecruitmentList?: () => void;
}> = ({
  companyName,
  scheduleWarning,
  hasOtherRecruitmentList = false,
  displayEndAt,
  scrollToOtherRecruitmentList,
}) => {
  const status = getScheduleWarningStatus(scheduleWarning, displayEndAt);

  const WARNING_TEXT = {
    entryDeadlineOver: {
      title: '募集締切が過ぎています',
      description:
        'すでに募集が終了している情報のため、応募はできませんのでご注意ください。',
    },
    eventEndOver: {
      title: '開催が終了しています',
      description:
        '開催が終了している募集情報です。参加はできませんのでご注意ください。',
    },
    contractEndOver: {
      title: '掲載が終了しています',
      description: '当サイトでは掲載が終了している情報です。',
    },
  };

  if (isReleasedRedesignRecruitment()) {
    const warningText =
      status === RECRUITMENT_SCHEDULE_WARNING_STATUS.ENTRY_DEADLINE_OVER
        ? WARNING_TEXT.entryDeadlineOver
        : status === RECRUITMENT_SCHEDULE_WARNING_STATUS.EVENT_END_OVER
          ? WARNING_TEXT.eventEndOver
          : WARNING_TEXT.contractEndOver;

    return (
      status !== RECRUITMENT_SCHEDULE_WARNING_STATUS.OK && (
        <div className="w-full flex flex-col gap-8 bg-white p-16 rounded-16 items-center">
          <h2 className="font-bold">{warningText.title}</h2>
          <div className="text-base text-black-1 leading px-8">
            {warningText.description}
          </div>
          {hasOtherRecruitmentList && scrollToOtherRecruitmentList && (
            <div className="w-full flex items-center justify-center mt-8">
              <div
                className=" bg-primary text-white py-8 px-24 text-base rounded-16 hover:opacity-80 inline-block cursor-pointer"
                onClick={scrollToOtherRecruitmentList}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    scrollToOtherRecruitmentList();
                  }
                }}
              >
                公開中の募集情報を見る
              </div>
            </div>
          )}
        </div>
      )
    );
  }
  return (
    status !== RECRUITMENT_SCHEDULE_WARNING_STATUS.OK && (
      <div>
        <p className="text-md text-notification-1 font-bold leading">
          {status === RECRUITMENT_SCHEDULE_WARNING_STATUS.ENTRY_DEADLINE_OVER
            ? WARNING_TEXT.entryDeadlineOver.description
            : status === RECRUITMENT_SCHEDULE_WARNING_STATUS.EVENT_END_OVER
              ? WARNING_TEXT.eventEndOver.description
              : WARNING_TEXT.contractEndOver.description}
        </p>
        {hasOtherRecruitmentList && scrollToOtherRecruitmentList && (
          <button
            className="text-primary-1 underline text-base leading hover:opacity-80 mt-4"
            children={`${companyName}の公開中の募集情報を見る`}
            onClick={scrollToOtherRecruitmentList}
          />
        )}
      </div>
    )
  );
};
